module.exports = __webpack_public_path__ + "static/media/clear-24px.5e9bd6f9.svg";